/* eslint no-template-curly-in-string: 0 */

import channel from '../../channel'
import isEmpty from 'lodash/isEmpty'
import { webcastUrlType } from '@bt-react/constants'

const getCurrentWebcastUrl = (channelData, webcastData) => {

  if (channel.features.customCommunicationUrl.isEnabled(channelData) && !isEmpty(webcastData.customUrl)) {

    return {
      value: webcastData.customUrl,
      type: webcastUrlType.WEBCAST_CUSTOM
    }

  }

  const channelCustomUrl = channel.features.customCommunicationUrl.getCustomCommunicationUrl(channelData)
  if (!isEmpty(channelCustomUrl)) {

    return {
      value: channelCustomUrl.replace('${commId}', webcastData.id),
      type: webcastUrlType.CHANNEL_CUSTOM
    }

  }

  return {
    value: webcastData.channelWebcastUrl,
    type: webcastUrlType.CHANNEL_DEFAULT
  }

}

export default getCurrentWebcastUrl
